import { z } from 'zod';

export const BaseComputeGroupSchema = z.object({
  computeResource: z.enum(['dedicated', 'automatic', 'group']),
  computeResourceGroup: z.string().nullable().optional(),
});

export const ComputeGroupSchemaValidation: Parameters<
  (typeof BaseComputeGroupSchema)['superRefine']
> = [
  async (data, ctx) => {
    if (data.computeResource === 'group' && !data.computeResourceGroup) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Compute resource group is required',
        path: ['computeResourceGroup'],
      });
    }
  },
];

export const ComputeGroupSchema = BaseComputeGroupSchema.superRefine(
  ...ComputeGroupSchemaValidation,
);

export type ComputeGroupSchemaFormValues = z.infer<typeof ComputeGroupSchema>;
